import View from './View';

export { default as View } from './View';
export { default as MovementForm } from './MovementView';

export default View;